import { UPDATE_EMAIL, UPDATE_PASSWORD, UPDATE_PROFILE } from 'constants/constants';
import { ACCOUNT } from 'constants/routes';
import { displayActionMessage } from 'helpers/utils';
import { call, put, select } from 'redux-saga/effects';
import { history } from 'routers/AppRouter';
import firebase from 'services/firebase';
import { setLoading } from '../actions/miscActions';
import { updateProfileSuccess } from '../actions/profileActions';

function* profileSaga({ type, payload }) {
  switch (type) {
    case UPDATE_EMAIL: {
      try {
        yield put(setLoading(false));
        yield call(firebase.updateEmail, payload.password, payload.newEmail);

        yield put(setLoading(false));
        yield call(history.push, '/profile');
        yield call(displayActionMessage, 'Email Updated Successfully!', 'success');
      } catch (e) {
        console.log(e.message);
      }
      break;
    }


    case UPDATE_PASSWORD: {
      try {
        yield put(setLoading(false));
        yield call(firebase.changePassword, payload.currentPassword, payload.newPassword);

        yield put(setLoading(false));
        yield call(history.push, '/profile');
        yield call(displayActionMessage, 'Password Updated Successfully!', 'success');
      } catch (e) {
        console.log(e.message);
      }
      break;
    }




    case UPDATE_PROFILE: {
      try {
        const state = yield select();
        const { email, password,newPassword } = payload.credentials;
        const { avatarFile, bannerFile, pdffile, linkIconFiles = [] } = payload.files;
        console.log('payload',payload)

        yield put(setLoading(true));

        // if email & password exist && the email has been edited
        // update the email
        if (email && password && email !== state.profile.email) {
          yield call(firebase.updateEmail, password, email);
        }


        if (password && newPassword ) {

          console.log('Password Change Called')
          yield call(firebase.changePassword, password, newPassword);
        }


        let profileUpdates = { ...payload.updates };

        if (linkIconFiles.length > 0) {
          const friends = [...(profileUpdates.friends || [])];

          for (const linkIcon of linkIconFiles) {
            const iconURL = yield call(
              firebase.storeImage,
              `${state.auth.id}-${linkIcon.id}`,
              'profile-links',
              linkIcon.file
            );
            const friendIndex = friends.findIndex((friend) => friend.id === linkIcon.id);

            if (friendIndex !== -1) {
              friends[friendIndex] = { ...friends[friendIndex], icon: iconURL };
            }
          }

          profileUpdates = { ...profileUpdates, friends };
        }

        if (avatarFile || bannerFile || pdffile || linkIconFiles.length > 0) {
          const bannerURL = bannerFile ? yield call(firebase.storeImage, state.auth.id, 'banner', bannerFile) : profileUpdates.banner;

          const avatarURL = avatarFile ? yield call(firebase.storeImage, state.auth.id, 'avatar', avatarFile) : profileUpdates.avatar;
          const pdfURL = pdffile ? yield call(firebase.storeImage, state.auth.id, 'pdf', pdffile) : profileUpdates.pdf;
//console.log('pdfURL',pdfURL)

//console.log('pdffile',pdffile)
//console.log('payload',payload)

          const updates = { ...profileUpdates, avatar: avatarURL, banner: bannerURL,pdf: pdfURL ? pdfURL : ""};

          yield call(firebase.updateProfile, state.auth.id, updates);
          yield put(updateProfileSuccess(updates));
        } else {
          yield call(firebase.updateProfile, state.auth.id, profileUpdates);
          yield put(updateProfileSuccess(profileUpdates));
        }

        yield put(setLoading(false));
        yield call(history.push, ACCOUNT);
        yield call(displayActionMessage, 'Profile Updated Successfully!', 'success');
      } catch (e) {
        console.log(e);
        yield put(setLoading(false));
        if (e.code === 'auth/wrong-password') {
          yield call(displayActionMessage, 'Wrong password, profile update failed :(', 'error');
        } else {
          yield call(displayActionMessage, `:( Failed to update profile. ${e.message ? e.message : ''}`, 'error');
        }
      }
      break;
    }
    default: {
      throw new Error('Unexpected action type.');
    }
  }
}

export default profileSaga;
